const MatchesFilter = function(el) {
	const self = this;

	self.elFilters = $(el).find('.js-filter');
	self.elPrimaryFilter = $(el).find('.js-filter-primary');
	self.elAutoFilter = $(el).find('.js-filter-auto');
	self.elMatchesRows = $(el).find('.matches .row');

	self.elCurrMatchRows = self.elMatchesRows;

	self.filters = {};
	self.filterCheck = null;
	self.tmr = null;

	self.matchesObj = {};
	self.filterInitOpts = {};

	self.init = () => {
		self.getMatchesObj();

		self.getOptsList('squad', Object.keys(self.matchesObj));
		self.filterCheck = $.param(self.filters);

		if (_ad.qString(location.search)) {
			self.handleUrlQuery();
		}

		if (history.pushState) {
			window.onpopstate = function (eve) {
				self.handleUrlQuery();
			}
		}
	};

	self.useMultiSquad = (metaData, squad) => {
		if (!self.matchesObj.hasOwnProperty(squad)) {
			self.matchesObj[squad] = {};

			self.matchesObj[squad]['types'] = [];
			self.matchesObj[squad]['grounds'] = [];
		}

		if (!(self.matchesObj[squad].types.indexOf(metaData.type.toString()) > -1)) {
			self.matchesObj[squad].types.push(metaData.type.toString());
		}

		if (!(self.matchesObj[squad].grounds.indexOf(metaData.ground.toString()) > -1)) {
			self.matchesObj[squad].grounds.push(metaData.ground.toString());
		}
	}

	self.getMatchesObj = () => {
		self.elMatchesRows.each((idx, elRow) => {
			const metaData = $(elRow).data();
			if (metaData.squad.toString().includes(',')) {
				const squads = metaData.squad.split(',');
				squads.forEach((squad) => {
					self.useMultiSquad(metaData, squad.trim());
				});
			} else {
				self.useMultiSquad(metaData, metaData.squad);
			}
		});

		self.elFilters.each((idx, elFilter) => {
			const filterName = $(elFilter).attr('name');
			self.filterInitOpts[filterName] = $(elFilter).find('option');
		})

		// console.log(self.filterInitOpts);
		// console.log(self.matchesObj);
	}

	self.setCurrFilter = () => {
		self.elFilters.each((idx, elFilter) => {
			let elFilterName = $(elFilter).attr('name');
			self.filters[elFilterName] = $(elFilter).val();
		});
	};

	self.applyFilters = () => {
		let selector = [];
		let exSquad = {};

		let allMatchesRowsDataAttr = {};
		for (let name in self.filters) {
			if (self.filters[name]) {
				if (!allMatchesRowsDataAttr[name]) {
					allMatchesRowsDataAttr[name] = [];
				}
				self.elMatchesRows.each((idx, elRow) => {
					const v = $(elRow).data(name);
					if (allMatchesRowsDataAttr[name].indexOf(v) === -1) {
						allMatchesRowsDataAttr[name].push(v);
					}
				});
			}
		}

		for (let name in self.filters) {
			if (self.filters[name]) {
				const filtered = allMatchesRowsDataAttr[name].filter((item) => item.toString().includes(self.filters[name]));
				filtered.forEach((item) => {
					if (name === 'squad') {
						selector.push({ [name]: item });
					} else {
						exSquad[name] = item;
					}
				});
			}
		}
		selector = selector.map((item) => Object.assign({}, item, exSquad));

		self.elMatchesRows.each((idx, elRow) => {
			$(elRow).addClass('hidden');
			$(elRow).addClass('hiding');
		});

		// isolate which rows to display
		self.elCurrMatchRows = self.elMatchesRows.filter((idx, el) => {
			return selector.some(r => {
				return Object.entries(r).every(([key, value]) => $(el).data(key) === value);
			});
		});
		self.elCurrMatchRows.each((idx, elCurrRow) => {
			$(elCurrRow).removeClass('hidden');
			$(elCurrRow).removeClass('hiding');
			(idx % 2 === 0) ? $(elCurrRow).addClass('alt') : $(elCurrRow).removeClass('alt');
		});
	};

	self.getOptsList = (name, arr) => {
		const dropdown = self.elFilters.filter('[name="' + name + '"]');
		dropdown.find('option').remove();

		const opts = self.filterInitOpts[name];
		opts.each((idx, opt) => {
			const optValue = $(opt).attr('value');
			if (!optValue.length || arr.includes(optValue)) {
				dropdown.append(opt);
			}
		});

		dropdown.val(dropdown.find('option:first').val()).change();
	};

	self.updateUrlQuery = () => {
		// To stop the filters changing the history state multiple times use a timeout
		if (self.tmr !== null) {
			clearTimeout(self.tmr);
		}

		setTimeout(function() {
			if (self.filterCheck === $.param(self.filters)) {
				return;
			}

			// Push the updated filter values to the URL/History
			const q = $.param(self.filters);
			if (history.pushState) {
				const href = location.protocol + '//' + location.host + location.pathname;
				history.pushState({}, '', `${href}?${q}`);
			}
		}, 100);
	};

	self.handleUrlQuery = () => {
		const qFilters = _ad.qString(location.search);

		if (self.filterCheck && self.filterCheck === $.param(qFilters)) {
			return;
		}

		if (qFilters) {
			self.filterCheck = $.param(qFilters);

			if (qFilters.squad !== self.filters.squad) {
				if (!!self.matchesObj[qFilters.squad]) {
					self.getOptsList('type', self.matchesObj[qFilters.squad].types);
					self.getOptsList('ground', self.matchesObj[qFilters.squad].grounds);
				}
			}

			Object.keys(qFilters).forEach((name) => {
				const dropdown = self.elFilters.filter('[name="' + name + '"]');

				if (dropdown.val() !== qFilters[name]) {
					dropdown.val(qFilters[name]).change();
				}
			});
		}
	};

	$(el).on('change', '.js-filter', function(eve) {
		self.setCurrFilter();
		self.applyFilters();
		self.updateUrlQuery();
	})
	.on('change', '.js-filter-primary', function(eve) {
		const currSquad = $(this).val();

		const types = self.elCurrMatchRows.map((idx, elRow) => $(elRow).data().type.toString()).get();
		const uniTypes = types.filter((item, pos) => types.indexOf(item) == pos);
		self.getOptsList('type', uniTypes);

		if (!!self.matchesObj[currSquad]) {
			self.getOptsList('ground', self.matchesObj[currSquad].grounds);
		}
	});
}

export default MatchesFilter;